export enum ApiRoutesSupport {
  Conversations = "admin/in-app-support/conversations"
}

export enum SupportConversationSubRoute {
  Messages = "messages",
  Takeover = "takeover",
  Release = "release",
  MarkRead = "mark-read",
  Mode = "mode"
}

export enum InAppConversationStatus {
  Ai = "ai",
  Human = "human",
  Closed = "closed"
}

export enum InAppMessageDirection {
  Inbound = "inbound",
  Outbound = "outbound"
}

export enum InAppMessageSender {
  Customer = "customer",
  Ai = "ai",
  Admin = "admin"
}

export enum InAppMessageType {
  Text = "text",
  Image = "image",
  Voice = "voice",
  // Outbound admin file attachment. `mediaUrl` holds the file, `mediaName` its
  // display name.
  Document = "document",
  // Outbound platform video (help/guide) the AI attaches to an answer.
  // `mediaUrl` holds the playable video URL, `text` an optional title.
  Video = "video"
}

export const SUPPORT_QUERY_KEY = "support";
